if (!customElements.get('wlsn-sticky-cta')) {
    class WLSNStickyCta extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                active: 'active',
                disabledStickyClass: 'disable-sticky-cta'
            };

            this.checkVisibility = this.checkVisibility.bind(this);
        }

        connectedCallback() {
            const hideOnClasses = (this.dataset.hideOnClasses || '')
                .split(',')
                .map((item) => item.trim())
                .filter(Boolean)
                .map((item) => (item.startsWith('.') ? item : `.${item}`));

            this.hideSelector = [`.${this.classes.disabledStickyClass}`, ...hideOnClasses].join(', ');

            window.addEventListener('scroll', this.checkVisibility);
            this.checkVisibility();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.checkVisibility);
        }

        checkVisibility() {
            let visible = false;
            const stickyDisabledSections = document.querySelectorAll(this.hideSelector);

            stickyDisabledSections.forEach((section) => {
                const rect = section.getBoundingClientRect();

                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    visible = true;
                }
            });

            if (visible) {
                this.classList.remove(this.classes.active);
            } else {
                this.classList.add(this.classes.active);
            }
        }
    }

    customElements.define('wlsn-sticky-cta', WLSNStickyCta);
}
